<template>
  <div class="kit">
    <div class="inspectoscope"
         v-for="item in kits"
         v-if="item.permission()"
         :key="item.id"
         @click="entry(item)">
      <div class="inner-inspectoscope">
        <i :class="[item.icon,'iconfont','kit-icon']" />
        <p class="inspectoscope-p">{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kit',
  data () {
    const that = this
    return {
      kits: [
        {
          id: 0,
          name: 'TKD检查器',
          icon: 'icon-TKDjianchaqi',
          path: '/kitDetail',
          permission: () => true
        },
        {
          id: 1,
          name: '市场洞察工具',
          icon: 'icon-guanjiancizhushou1',
          path: '/keywordAssistant',
          permission: () => {
            return that.getPermission(that.$permissionData.keywordAssistant.englishName)
          }
        },
        {
          id: 2,
          name: '行业效果报告',
          icon: 'icon-baogaogongdan',
          path: '/industruReport',
          permission: () => {
            return that.getPermission(that.$permissionData.industruReport.englishName)
          }
        }
      ]
    }
  },
  methods: {
    entry (col) {
      this.$router.push({ path: col.path })
    }


  },
}
</script>

<style lang="scss" scoped>
.kit {
  // display: flex;
}
.inspectoscope {
  float: left;
  width: 20%;
  height: 200px;
  margin-right: 10px;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(89, 90, 110, 0.05);
  border: 1px solid rgb(238, 237, 237);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  .inner-inspectoscope {
    text-align: center;
    line-height: 30px;
  }
  .inspectoscope-p {
    color: black;
  }
  .kit-icon {
    font-size: 35px;
    color: #5bc66d;
  }
}
</style>
